import { string } from "prop-types";

import { iconSizeType } from "../components/cssLength";

const RadioDot = ({ size, color }) => (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", width: size, height: size }}
  >
    <circle cx="256" cy="256" r="186" fill={color} />
    <circle
      cx="256"
      cy="256"
      r="186"
      fill="none"
      stroke={color}
      strokeWidth="140"
      opacity="0.4"
    />
  </svg>
);

RadioDot.propTypes = { size: iconSizeType, color: string };
export default RadioDot;
